import { render, staticRenderFns } from "./Perfumadas2023.vue?vue&type=template&id=fa0898fc&scoped=true"
import script from "./Perfumadas2023.vue?vue&type=script&lang=js"
export * from "./Perfumadas2023.vue?vue&type=script&lang=js"
import style0 from "./Perfumadas2023.vue?vue&type=style&index=0&id=fa0898fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0898fc",
  null
  
)

export default component.exports